module.exports = __webpack_public_path__ + "static/media/docx.845c9795.svg";